const GrupoConceitoList = () =>
  import("~/components/Views/Prova/GrupoConceito/List");
const GrupoConceitoNew = () =>
  import("~/components/Views/Prova/GrupoConceito/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Configurações", link: "" }
];

export const grupoConceito = [
  {
    path: "configuracoes/grupo-conceito",
    component: GrupoConceitoList,
    name: "Grupo de Conceito",
    meta: {
      title: "Grupo de Conceito",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/grupo-conceito/new",
    component: GrupoConceitoNew,
    name: "Novo Grupo de Conceito",
    meta: {
      title: "Novo Grupo de Conceito",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/grupo-conceito/:id",
    component: GrupoConceitoNew,
    name: "Alterar Grupo de Conceito",
    meta: {
      title: "Alterar Grupo de Conceito",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/configuracao/grupoConceito.js